import { createContext } from 'react';

export const SearchTemplatePageContext = createContext<boolean>(false);
